import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    attachments: {
        [theme.fn.smallerThan("xs")]: {
            maxWidth: "100%",
        },

        fontSize: rem(12),
    },

    wrapper: {
        marginTop: "0.375rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: rem(8),

        ".mantine-Button-root": {
            padding: "9px 12px",
            minHeight: "1.875rem",
            height: "auto",
        },
    },

    container: {
        display: "flex",
        flexDirection: "column",
        gap: rem(6),
    },
}))
